<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <banner-target ref="bannerTarget" :target="info.target" :address="info.address" :target_msg="info.target_msg" :target_id="info.target_id" :source_type="source_type" @target1="target1"></banner-target>

      <el-form-item label="标题" prop="title" v-if="
        [
          'vip_level_detail',
          'target_h5',
          'group_course_list',
          'group_course_p_list',
          'group_product_list',
          'flash_sale_course',
          'flash_sale_course_p',
          'flash_sale_product',
          'salon_list'
        ].indexOf(theTarget) >= 0
      ">
        <el-input
          v-model="info.title"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片" v-if="
        [
          'vip_level_detail',
          'target_h5',
          'group_course_list',
          'group_course_p_list',
          'group_product_list',
          'flash_sale_course',
          'flash_sale_course_p',
          'flash_sale_product',
          'salon_list'
        ].indexOf(theTarget) >= 0
      ">
        <el-upload
          class="avatar-uploader"
          :action="ossAction"
          :show-file-list="false"
          :http-request="uploadOSSRequest"
          :before-upload="beforeImageUpload"
        >
          <img v-if="info.resource" :src="info.resource" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，尺寸275x320px，大小不超过100K
          </div>
        </el-upload>
      </el-form-item>

      
      
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="createUpdate()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import { createUpdateMessage, getMessageDetail } from "@/api/live";
import bannerTarget from '../../components/bannerTarget.vue';

export default {
  components: { bannerTarget },
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      theTarget: '',
      source_type: 1,
      info: {
        period_id: this.$route.query.period_id,
        course_id: this.$route.query.course_id,
        id: 0,
        title: "",
        type: "custom",
        resource: "",
        target: '',
        target_id: 0,
        target_msg: ""
      },

    };
  },
  created: function () {
    this.info.id = this.$route.query.id;
    if (this.info.id > 0) {
      this.getInfo();
    }
    
  },
  methods: {
    target1(e) {
      this.theTarget = e;
    },
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.resource = fileUrl;
        });
      });
    },

    getInfo() {
      this.loading = true;
      getMessageDetail({
        id: this.info.id,
      }).then((response) => {
        this.info = response.data;
        this.loading = false;
      });
    },
    createUpdate() {
      this.info.target = this.$refs.bannerTarget.theTarget;
      this.info.address = this.$refs.bannerTarget.theAddress;
      this.info.target_id = this.$refs.bannerTarget.theTargetId;
      if (this.info.target == '') {
        this.$message.error('请选择跳转目的');
        return;
      }
      if (['live_detail', 'course_detail', 'workshop_detail', 'book_detail', 'product_detail', 'course_package'].indexOf(this.info.target) >= 0) {
        if (this.info.target_id <= 0) {
          this.$message.error('请选择跳转目的');
          return;
        }
      }
      if (this.info.target == 'target_h5') {
        if (this.info.address == '') {
          this.$message.error('请填写运营H5活动地址');
          return;
        }
      }
      this.updateLoading = true;
      createUpdateMessage(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/live/message",
              query: {
                course_id: this.$route.query.course_id,
                period_id: this.$route.query.period_id
              }
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 275px;
  height: 320px;
  line-height: 320px;
  text-align: center;
}
.avatar {
  width: 275px;
  height: 320px;
  display: block;
  background: #D8D8D8;
  border-radius: 6px;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>